import React, { Component } from 'react'
import Griddle, {plugins, RowDefinition, ColumnDefinition} from 'griddle-react'
import Text from 'react-text'
import columns from './columns'
import {Consumer} from '../../context'

const Layout = ({Table}) => (<div className="activity-table"><Table /></div>)

const ActivityHeader = ({title}) => <Text id={`${title}_header_title`}/>

function NoResults (props) {
  return (
    <div className="no-results">
      <Text id="dashboard-recent-activity-no-results" />
    </div>
  )
}

export default function  RecentActivity (props) {
  return (<Consumer>{ context => {
    const {activity, locked} = context
    const columnDefinitions = ['date', 'group', 'students', 'lesson']
      .map(id => {
        const Column = columns[id]
        return (<ColumnDefinition
          id={id}
          key={id}
          customComponent={Column}
          customHeadingComponent={ActivityHeader}
        />)
    })
    return (
      <Griddle
        data={activity}
        components={{Layout, NoResults}}
      >
       <RowDefinition>
         {columnDefinitions}
       </RowDefinition>
      </Griddle>
    )
  }}</Consumer>)
}
